// extracted by mini-css-extract-plugin
export var container = "_80-0";
export var error = "_80-9";
export var label = "_80-5";
export var light = "_80-6";
export var md = "_80-3";
export var sm = "_80-2";
export var thin = "_80-8";
export var thinBold = "_80-7";
export var vertical = "_80-4";
export var xs = "_80-1";